import React from 'react';
import './WhereWeWork.css';
import afgMap from '../images/slider4_freelancing.jpg';

const WomenAndChildren: React.FC = () => {
  const scopeOfWork = [
    {
      title: 'Empower Women and Children',
      description: 'Creating inclusive programs that support the empowerment of women and children through education, skills development, and community engagement.',
      icon: 'fas fa-hands-helping' // Empowerment and support icon
    }
  ];

  return (
    <div className="where-we-work-page">

      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>Our Integrated Approach to Empowering Women and Children</h2>
            <p>NORA operates empowerment programs for women and children across all 34 provinces of Afghanistan through dedicated community teams</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA Women & Children Empowerment Coverage" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>

      {/* Scope of Work Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            {scopeOfWork.map((item, index) => (
              <div key={index} className="scope-card">
                <div className="scope-card-header">
                  <i className={item.icon}></i>
                  <h3><strong>Our Integrated Approach to Empowering Women and Children</strong></h3>
                </div>
                <p className="scope-card-description">
                  <strong>Empowering women and children is not merely an objective; it is the essential foundation for a healthy, educated, and sustainable society.</strong> 
                  <br/><br/>
                  In Afghanistan, women and children often face deep-rooted social, cultural, and economic barriers that systematically limit their access to education, healthcare, and economic opportunities. These constraints stifle individual potential and impede the broader progress of families, communities, and the nation.
                  <br/><br/>
                  <strong>Our institute is dedicated to dismantling these barriers through targeted, inclusive programs that foster empowerment at both individual and community levels.</strong> We focus on equipping women and children with the tools to lead, thrive, and shape their own futures.
                  <br/><br/>
                  <strong><h3>Our integrated empowerment initiatives include:</h3></strong>
                  <br/><br/>
                  <strong>1. Comprehensive Educational Access:</strong> Implementing educational programs and workshops specifically designed for women and children to enhance literacy, develop digital skills, and build professional competencies that open doors to new opportunities.
                  <br/><br/>
                  <strong>2. Economic Empowerment Pathways:</strong> Providing vocational training and freelancing programs that enable women, particularly those home-bound or facing mobility restrictions, to generate sustainable income and achieve financial independence from home.
                  <br/><br/>
                  <strong>3. Health & Well-being Focus:</strong> Conducting community-based health, hygiene, and nutrition awareness programs to safeguard the physical and mental well-being of women and children in underserved and marginalized communities.
                  <br/><br/>
                  <strong>4. Leadership & Confidence Building:</strong> Facilitating mentorship circles and leadership development workshops to strengthen women's self-confidence, decision-making capabilities, and active participation in social, economic, and community life.
                  <br/><br/>
                  <strong>5. Community Advocacy & Protection:</strong> Leading awareness campaigns and community dialogues on gender equality, women's rights, and child protection to shift social norms and create a more supportive, inclusive environment for all.
                  <br/><br/>
                  <strong>6. Targeted Support for Vulnerable Groups:</strong> Ensuring our programs actively reach and include the most marginalized and at-risk women and children, leaving no one behind due to poverty, disability, geographic isolation, or social exclusion.
                  <br/><br/>
                  <strong>7. Child-Centric Development Programs:</strong> Creating safe spaces and specialized programs for children that focus on holistic development, including early childhood education, psychosocial support, creative expression, and preparation for future opportunities.
                  <br/><br/>
                  <strong>Our Goal:</strong> To cultivate a generation of empowered Afghan women and children who possess the knowledge, skills, confidence, and resources they need to thrive, contribute positively to society, and become active architects of their communities' prosperity and well-being.
                  <br/><br/>
                  <strong>A Call for Partnership in Empowerment</strong>
                  <br/><br/>
                  We invite domestic and international donors, organizations, and advocates to join us in this transformative mission. Your partnership is crucial to expanding our reach, deepening the impact of our programs, and creating sustainable, systemic change. By investing in the empowerment of women and children, you are investing in the very cornerstone of Afghanistan's peaceful and prosperous future.
                  <br/><br/>
                  <strong>Together, we can build a brighter future where every Afghan woman and child can realize their full potential and contribute to a more equitable and thriving society.</strong>
                  <br/><br/>
                  <strong>Your support today will shape the leaders and change-makers of tomorrow's Afghanistan.</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default WomenAndChildren;